var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
// main handler for this mixin
import { Const } from './provider/candle-history/lib/const.cls';
import { mapActions } from 'vuex';
import { scalpert } from './lib/scalpert.cls';
import * as scalpertStoreExtensions from './provider/candle-history';
// add plugin store extensions to store properties
var state = __assign({}, scalpertStoreExtensions.stateExt);
var actions = __assign({}, scalpertStoreExtensions.actionsExt);
var mutations = __assign({}, scalpertStoreExtensions.mutationsExt);
var getters = __assign({}, scalpertStoreExtensions.gettersExt);
// new store module definition
var scalpertStore = {
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
};
var intervalValue = null;
var _store;
var _that;
// main mixin to load the new store module
export var scalpertMixins = {
    created: function () {
        // dynamically extend store with scalpertStore plugin
        _store = this.$store;
        _that = this;
        if (!(_store && _store.state && _store.state[scalpert.STORE_MODULE_NAME])) {
            this.$store.registerModule(scalpert.STORE_MODULE_NAME, scalpertStore);
        }
    },
    methods: __assign(__assign({}, mapActions({
        _runTradingAccount: Const.RUN_GET_TRADERING_ID,
        _getTraderInformation: Const.RUN_GET_TRADERING_INFO,
        _getTraderInformationSocket: Const.RUN_GET_TRADERING_INFO_SOCKET,
        _runModifyOrder: Const.RUN_MODIFY_ORDER,
        _runGetPayInLink: Const.RUN_GET_PAYIN_LINK,
        _runGetPayOut: Const.RUN_GET_PAY_OUT,
        _runRequiredDetail: Const.RUN_ORDER_REQUIRED_DETAIL,
        _runExitConverOrder: Const.RUN_EXIT_COVER_ORDER,
        _runExitBracketOrder: Const.RUN_EXIT_BRACKET_ORDER,
        _runSquareOffOrder: Const.RUN_SQUARE_OFF,
        _runBuySellBO: Const.RUN_PLACE_BRACKET_ORDER,
        _runPartialPositionConversion: Const.RUN_PARTIAL_POSITION,
        _runGetUserExtraInfo: Const.RUN_GET_USER_INFO,
        _runVerifyOTP: Const.RUN_VERIFY_OTP,
        _runUserLogs: Const.RUN_GET_USER_LOGS,
        _runExchaneMsg: Const.RUN_GET_EXCHANGE_MSG,
        _runTraderLogout: Const.RUN_USER_LOGOUT,
        _runuserupdateinfo: Const.RUN_UPDATE_USER_INFO,
        _runTwoFactorAuth: Const.RUN_TWO_FACTOR_AUTH,
        _runVerification: Const.RUN_VERIFICATION_AUTH_TOKEN,
        _runOneTimeVerification: Const.RUN_VERIFICATION_AUTH_TOKEN_ONE_TIME,
        _runBuySellTrade: Const.RUN_BUY_SELL_TRADE,
        _runDeleteOrder: Const.RUN_DELETE_ORDER,
        _runBuySellMarketTrade: Const.RUN_BUY_SELL_MARKET,
        _runTradeClose: Const.RUN_CLOSE_TRADE,
        _runGetTradeHistory: Const.RUN_GET_HISTORY,
        _runGetDasboardData: Const.RUN_GET_DASHBOARD_DATA,
        _runGetOrderHistory: Const.RUN_GET_ORDER_HISTORY,
        _runGetOpenOrder: Const.RUN_GET_OPEN_ORDER,
        _runGetMarginInfo: Const.RUN_GET_MARGIN_INFO,
        _runGetCardList: Const.RUN_GET_CARDS_LIST,
        _runGetTicketList: Const.RUN_GET_TICKET_LIST,
        _runSaveTicketList: Const.RUN_SAVE_TICKET,
        _runGetAllIsins: Const.RUN_GET_ALL_ISINS,
        _runGetScripInfo: Const.RUN_GET_SCRIP_INFO,
        _runGetCalculatorValue: Const.RUN_OPTION_CALCULATOR,
        _runGetChart: Const.RUN_GET_CHART_DATA
    })), { 
        // send_notification: function(msg){
        //   // Notifications
        //   Vue.$notify({
        //     group: 'foo',
        //     title: 'Success!',
        //     text: msg,
        //     type: 'success',
        //   });
        // },
        beautifyname: function (i) {
            try {
                var option = "";
                var beautify = i.item.m;
                if ('strikePrice' in i.item.other_info) {
                    var expDate = i.item.other_info.expiryDate.split("-");
                    var expDateClean = expDate[0] + " " + expDate[1];
                    if (i.item.m.toLowerCase().endsWith('ce')) {
                        option = "CE";
                    }
                    else if (i.item.m.toLowerCase().endsWith('pe')) {
                        option = "PE";
                    }
                    else if (i.item.m.toLowerCase().endsWith('fut')) {
                        option = "FUT";
                    }
                    var strikePrice = i.item.other_info.strikePrice.toString();
                    if ((parseInt(strikePrice.split(".")[1])) == 0) {
                        strikePrice = parseInt(strikePrice);
                    }
                    if (parseInt(strikePrice) !== 0 && parseInt(strikePrice) !== -1 && strikePrice !== undefined) {
                        beautify = i.item.other_info.Scripname + " " + expDateClean + " " + strikePrice + " " + option;
                    }
                    else {
                        beautify = i.item.other_info.Scripname + " " + expDateClean + " " + option;
                    }
                }
                return beautify;
            }
            catch (e) {
                return i.item.m;
            }
        }, processName: function (inputText) {
            var output = [];
            var json = inputText.split(' ');
            json.forEach(function (item) {
                output.push(item.replace(/\'/g, '').split(/(\d+)/).filter(Boolean));
            });
            return output;
        }, beautifynamePosition: function (positionInfo) {
            var option = "";
            var beautify = '';
            if (positionInfo.Tsym.toLowerCase().endsWith('eq') || positionInfo.Exchange.toLowerCase() == 'bse') {
                beautify = positionInfo.Tsym;
            }
            else {
                var dateClean = positionInfo.Expdate.split(",")[0];
                if (positionInfo.Tsym.toLowerCase().endsWith('ce')) {
                    option = "CE";
                }
                else if (positionInfo.Tsym.toLowerCase().endsWith('pe')) {
                    option = "PE";
                }
                else if (positionInfo.Tsym.toLowerCase().endsWith('fut')) {
                    option = "FUT";
                }
                if (parseInt(positionInfo.Stikeprc) !== 0) {
                    beautify = this.processName(positionInfo.Symbol)[0][0] + " " + dateClean + " " + positionInfo.Stikeprc + " " + option;
                }
                else {
                    beautify = this.processName(positionInfo.Symbol)[0][0] + " " + dateClean + " " + option;
                }
            }
            return beautify;
        }, showMessage: function (message) {
            // const vm = new Vue()
            // vm.toasted.show(message)
            // Vue.toasted.show(message);
        }, beautifynameOrders: function (positionInfo) {
            var option = "";
            var beautify = '';
            if (positionInfo.Trsym.toLowerCase().endsWith('eq') || positionInfo.Exchange.toLowerCase() == 'bse') {
                beautify = positionInfo.Trsym;
            }
            else {
                var dateClean = positionInfo.ExpDate.split(",")[0];
                if (positionInfo.Trsym.toLowerCase().endsWith('ce')) {
                    option = "CE";
                }
                else if (positionInfo.Trsym.toLowerCase().endsWith('pe')) {
                    option = "PE";
                }
                else if (positionInfo.Trsym.toLowerCase().endsWith('fut')) {
                    option = "FUT";
                }
                if (parseInt(positionInfo.strikePrice) !== 0 && option !== 'FUT') {
                    beautify = this.processName(positionInfo.Sym)[0][0] + " " + dateClean + " " + positionInfo.strikePrice + " " + option;
                }
                else {
                    beautify = this.processName(positionInfo.Sym)[0][0] + " " + dateClean + " " + option;
                }
            }
            return beautify;
        }, update_positions: function (data) {
            if (!(Array.isArray(data))) {
                data = [data];
            }
            var get_new = 0;
            var old_open_order = _store.getters[Const.GET_OPEN_ORDER];
            var _loop_1 = function () {
                var current_order = data[i];
                data[i].order_id = data[i].non;
                data[i].symbol = data[i].ts;
                data[i].open_price = data[i].trigprc;
                data[i].volume = data[i].qtf;
                data[i]['Other'] = {};
                data[i]['Other']['Status'] = data[i].os;
                data[i]['Other']['RejReason'] = data[i].rjr;
                data[i]['Other']['Trsym'] = data[i].ts;
                data[i]['Other']['Pcode'] = data[i].prod;
                if (data[i].os == 'open' || data[i].os == 'complete' || data[i].os == 'rejected' || data[i].os == 'cancelled' || data[i].os == 'trigger pending') {
                    get_new = 1;
                }
                if (data[i].tt == 'B') {
                    data[i].type = 'Buy';
                }
                if (data[i].tt == 'S') {
                    data[i].type = 'Sell';
                }
                k = 0;
                found = old_open_order.some(function (el) {
                    if (parseInt(el.non) === parseInt(current_order.non)) {
                        old_open_order.splice(k, 1);
                    }
                    k++;
                });
                if (i == data.length - 1) {
                    var all_open_order = __spreadArray(__spreadArray([], data, true), old_open_order, true);
                    _store.commit(Const.SET_OPEN_ORDER, all_open_order);
                    if (get_new)
                        _that.refresh_data();
                }
            };
            var k, found;
            for (var i = 0; i < data.length; i++) {
                _loop_1();
            }
        }, update_user_log: function () {
            _that.update_message();
        }, update_watch_list: function (data) {
            _store.commit(Const.SET_WATCH_LIST, data);
        }, update_message: function () {
            _that._runUserLogs();
        }, update_orders_state: function (data) {
            _store.commit(Const.SET_OPEN_ORDER, data);
        }, update_position_state: function (data) {
            _store.commit(Const.SET_OPEN_POSITION, data);
        }, intialize_depth: function () {
            var dp = {
                "bno": "2",
                "bp": "--",
                "bp1": "--",
                "bp2": "--",
                "bp3": "--",
                "bp4": "--",
                "bs": "--",
                "bs1": "--",
                "bs2": "--",
                "bs3": "--",
                "bs4": "--",
                "bq": "--",
                "bq2": "--",
                "name": "dp",
                "sp": "--",
                "sp2": "--",
                "sp4": "--",
                "type": "depth"
            };
            _store.commit(Const.SET_MARKET_DEPTH, dp);
        }, update_depth: function (data) {
            var market_depth_old = _store.getters[Const.GET_MARKET_DEPTH];
            for (var prop in data) {
                if (data.hasOwnProperty(prop)) {
                    // Push each value from `obj` into `extended`
                    if (data[prop] != '') {
                        market_depth_old[prop] = data[prop];
                    }
                }
            }
            _store.commit(Const.SET_MARKET_DEPTH, market_depth_old);
        }, update_socket_indicator: function (data) {
            _store.commit(Const.SET_SOCKET_INDICATOR, data);
        }, user_can_delete: function (matched_instrument_id) {
            try {
                // `this` points to the vm instance
                var calculated_pnl = 0;
                for (var j = 0; j < this.$store.getters['GET_TRADERING_INFO'].position.trades.trade.length; j++) {
                    var trading_info = this.$store.getters['GET_TRADERING_INFO'].position.trades.trade[j];
                    if (trading_info.$.instrmt_id == matched_instrument_id)
                        return false;
                }
                return true;
            }
            catch (ex) {
                return true;
            }
        }, getOrderPositiion: function () {
            this._getTraderInformation({});
        }, refresh_data: function () {
            var self = this;
            this._getTraderInformation({});
            // self._getTraderInformation(self.currentAccount)
            // this.intervalValue = setInterval(function(){ self._getTraderInformation(self.currentAccount) }, 5000);
        }, select_trading_account: function (value, platform) {
            this.balance = 0;
            this.equity = 0;
            this.freemargin = 0;
            this._getTraderInformation({
                "login": value,
                "platform": platform,
                "page": "TRADER_DASHBOARD"
            });
            this.selectedValue = value;
            this.refresh_data();
            // this.intervalValue = setInterval(this._getTraderInformation(), 1000);
        }, stopInterval: function () {
            var self = this;
            clearInterval(this.intervalValue);
            this.intervalValue = null;
        }, getHistory: function () {
            var current_account = this.currentAccount;
            current_account.page = 'HISTORY';
            this._runGetTradeHistory(current_account);
        }, current_mn_price: function (type, intrument_price_to_be_fetch) {
            try {
                // const catched_item_data = this.$store.getters[Const.GET_PROVIDERS]['price-feed'].iCache.getItems()
                // for (var k = 0; k < Object.keys(catched_item_data).length; k++) {
                //   let cached_info = catched_item_data[Object.keys(catched_item_data)[k]]
                //   if(cached_info.item.i == intrument_price_to_be_fetch){
                //     if(type == "B") return cached_info.item.B
                //     if(type == "A") return cached_info.item.A
                //   }
                return 1;
            }
            catch (ex) {
                return 1;
            }
        } }),
    computed: {
        // provide computed value for view update
        traderBasicInfo: function () {
            return this.$store.getters['GET_USER'];
        },
        get_watch_list: function () {
            // console.log("this.select_watch_list", this.select_watch_list)
            try {
                var market_watch_list = this.$store.getters['GET_WATCH_LIST'];
                var selected_mw = this.traderBasicInfo.user.profile.selected_mw;
                if (market_watch_list.length > selected_mw) {
                    this.select_watch_list = market_watch_list[selected_mw].id + '-' + selected_mw + '-' + market_watch_list[selected_mw].watchName;
                }
                else {
                    this.select_watch_list = market_watch_list[0].id + '-0' + market_watch_list[0].watchName;
                }
                return this.$store.getters['GET_WATCH_LIST'];
            }
            catch (ex) {
                console.log(ex);
                return [];
            }
        },
        marketStatus: function () {
            return this.$store.getters['GET_MARKET_STATUS'];
        },
        exchEnabled: function () {
            try {
                return this.$store.getters['GET_USER'].user.profile.exchArr.split(",");
            }
            catch (ex) {
                return [];
            }
        },
        PCodeEnabled: function () {
            try {
                return this.$store.getters['GET_USER'].user.profile.pcode.split(",");
            }
            catch (ex) {
                return [];
            }
        },
        userdata: function () {
            try {
                // `this` points to the vm instance
                return this.$store.getters['GET_MARGIN'];
            }
            catch (ex) {
                return [];
            }
        },
        market_depth: function () {
            try {
                return this.$store.getters['GET_MARKET_DEPTH'];
            }
            catch (ex) {
                return [];
            }
        },
        traderHistory: function () {
            try {
                // `this` points to the vm instance
                return this.$store.getters['GET_CLOSED_ORDER'];
            }
            catch (ex) {
                return [];
            }
        },
        openHoldings: function () {
            try {
                // `this` points to the vm instance
                return this.$store.getters['GET_OPEN_HOLDINGS'];
            }
            catch (ex) {
                return [];
            }
        },
        userExtraInfo: function () {
            try {
                // `this` points to the vm instance
                return this.$store.getters[Const.GET_USER_EXTRA_INFO][0];
            }
            catch (ex) {
                return [];
            }
        },
    },
    mounted: function () {
        // this._runSessionget()
        // // this._getTraderInformation();
        // this.$store.dispatch(this._runSessionget())
    },
};
// export all mixins for data-warehouse plugin



//////////////////
// WEBPACK FOOTER
// ./src/plugins/scalpert/index.ts
// module id = null
// module chunks = 